/**
 * /admin/legal-holds — Legal hold register (route shell).
 * Screen impl in `./legal-holds-screen.tsx`, lazy-loaded.
 */

import { createFileRoute, lazyRouteComponent } from '@tanstack/react-router';

export const Route = createFileRoute('/admin/legal-holds')({
  component: lazyRouteComponent(
    () => import('./legal-holds-screen'),
    'AdminLegalHolds',
  ),
});
